var _module_exports = "<span\n  ng-repeat=\"fragment in fragments track by $index\"\n  ng-if=\"fragment\"\n  ng-class=\"{ highlighted: $odd }\"\n>{{fragment}}</span>\n";;
var path = '/builds/observability/imm/signalview/src/legacy/common/ui/highlight/highlight.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;